// import React, { useEffect, useRef, useState } from 'react';
// import './App.css';
// import ContactForm from "./ContactForm";

// function App() {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isLoading, setIsLoading] = useState(true);
//   const canvasRef = useRef(null);
//   const loadingScreenRef = useRef(null);
//   const navContainerRef = useRef(null);
//   const progressBarRef = useRef(null);
//   const contactFormRef = useRef(null);
//   const successMessageRef = useRef(null);
//   const mobileMenuRef = useRef(null);

//   // Neural Grid Animation
//   useEffect(() => {
//     if (!canvasRef.current) return;

//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');
//     let animationId;

//     // Grid configuration
//     const grid = {
//       nodes: [],
//       connections: [],
//       mouseInfluenceRadius: 200,
//       originalPositions: new Map(),
//       isMouseOver: false,
//       mouseX: 0,
//       mouseY: 0
//     };

//     // Resize canvas
//     function resizeCanvas() {
//       canvas.width = window.innerWidth;
//       canvas.height = window.innerHeight;
//       initGrid();
//     }

//     // Initialize grid nodes
//     function initGrid() {
//       grid.nodes = [];
//       grid.connections = [];
//       grid.originalPositions.clear();

//       // Create high-density grid
//       const spacing = 40;
//       const cols = Math.ceil(canvas.width / spacing) + 1;
//       const rows = Math.ceil(canvas.height / spacing) + 1;

//       // Create nodes
//       for (let y = 0; y < rows; y++) {
//         for (let x = 0; x < cols; x++) {
//           const node = {
//             x: x * spacing,
//             y: y * spacing,
//             originalX: x * spacing,
//             originalY: y * spacing,
//             velocityX: 0,
//             velocityY: 0,
//             size: Math.random() * 1.2 + 0.3
//           };
//           grid.nodes.push(node);
//           grid.originalPositions.set(node, { x: node.x, y: node.y });
//         }
//       }

//       // Create connections
//       for (let i = 0; i < grid.nodes.length; i++) {
//         for (let j = i + 1; j < grid.nodes.length; j++) {
//           const nodeA = grid.nodes[i];
//           const nodeB = grid.nodes[j];
//           const distance = Math.sqrt(
//             Math.pow(nodeA.x - nodeB.x, 2) +
//             Math.pow(nodeA.y - nodeB.y, 2)
//           );

//           if (distance < spacing * 1.8) {
//             grid.connections.push({
//               nodeA: nodeA,
//               nodeB: nodeB,
//               distance: distance
//             });
//           }
//         }
//       }
//     }

//     // Physics update
//     function updatePhysics() {
//       const damping = 0.9;
//       const springStrength = 0.08;
//       const mouseStrength = 0.3;

//       grid.nodes.forEach(node => {
//         // Return to original position force
//         const dx = node.originalX - node.x;
//         const dy = node.originalY - node.y;

//         // Spring force
//         node.velocityX += dx * springStrength;
//         node.velocityY += dy * springStrength;

//         // Mouse attraction
//         if (grid.isMouseOver) {
//           const mouseDx = grid.mouseX - node.x;
//           const mouseDy = grid.mouseY - node.y;
//           const mouseDistance = Math.sqrt(mouseDx * mouseDx + mouseDy * mouseDy);

//           if (mouseDistance < grid.mouseInfluenceRadius) {
//             const influence = 1 - (mouseDistance / grid.mouseInfluenceRadius);
//             node.velocityX += mouseDx * influence * mouseStrength;
//             node.velocityY += mouseDy * influence * mouseStrength;
//           }
//         }

//         // Apply velocity with damping
//         node.x += node.velocityX;
//         node.y += node.velocityY;
//         node.velocityX *= damping;
//         node.velocityY *= damping;

//         // Prevent excessive drifting
//         const maxDrift = 30;
//         const currentDx = node.x - node.originalX;
//         const currentDy = node.y - node.originalY;
//         const currentDistance = Math.sqrt(currentDx * currentDx + currentDy * currentDy);

//         if (currentDistance > maxDrift) {
//           const angle = Math.atan2(currentDy, currentDx);
//           node.x = node.originalX + Math.cos(angle) * maxDrift;
//           node.y = node.originalY + Math.sin(angle) * maxDrift;
//         }
//       });
//     }

//     // Render grid
//     function renderGrid() {
//       ctx.clearRect(0, 0, canvas.width, canvas.height);

//       // Draw connections
//       ctx.strokeStyle = 'rgba(42, 140, 110, 0.1)';
//       ctx.lineWidth = 0.5;

//       grid.connections.forEach(conn => {
//         const currentDistance = Math.sqrt(
//           Math.pow(conn.nodeA.x - conn.nodeB.x, 2) +
//           Math.pow(conn.nodeA.y - conn.nodeB.y, 2)
//         );

//         if (currentDistance < 80) {
//           const opacity = Math.max(0.02, 0.15 * (1 - currentDistance / 80));
//           ctx.strokeStyle = `rgba(42, 140, 110, ${opacity})`;

//           ctx.beginPath();
//           ctx.moveTo(conn.nodeA.x, conn.nodeA.y);
//           ctx.lineTo(conn.nodeB.x, conn.nodeB.y);
//           ctx.stroke();
//         }
//       });

//       // Draw nodes
//       grid.nodes.forEach(node => {
//         // Calculate brightness based on mouse proximity
//         let brightness = 1;
//         if (grid.isMouseOver) {
//           const dx = grid.mouseX - node.x;
//           const dy = grid.mouseY - node.y;
//           const distance = Math.sqrt(dx * dx + dy * dy);
//           if (distance < grid.mouseInfluenceRadius) {
//             brightness = 0.6 + 0.4 * (1 - distance / grid.mouseInfluenceRadius);
//           }
//         }

//         // Brand color #2a8c6e
//         const r = Math.floor(42 * brightness);
//         const g = Math.floor(140 * brightness);
//         const b = Math.floor(110 * brightness);

//         // Draw node
//         ctx.fillStyle = `rgb(${r}, ${g}, ${b})`;
//         ctx.beginPath();
//         ctx.arc(node.x, node.y, node.size, 0, Math.PI * 2);
//         ctx.fill();

//         // Draw subtle glow
//         const gradient = ctx.createRadialGradient(
//           node.x, node.y, node.size,
//           node.x, node.y, node.size * 2.5
//         );
//         gradient.addColorStop(0, `rgba(42, 140, 110, 0.4)`);
//         gradient.addColorStop(1, 'transparent');

//         ctx.fillStyle = gradient;
//         ctx.beginPath();
//         ctx.arc(node.x, node.y, node.size * 2.5, 0, Math.PI * 2);
//         ctx.fill();
//       });
//     }

//     // Animation loop
//     function animate() {
//       updatePhysics();
//       renderGrid();
//       animationId = requestAnimationFrame(animate);
//     }

//     // Mouse event handlers
//     const handleMouseMove = (e) => {
//       grid.mouseX = e.clientX;
//       grid.mouseY = e.clientY;
//       grid.isMouseOver = true;
//     };

//     const handleMouseLeave = () => {
//       grid.isMouseOver = false;
//     };

//     // Initialize and start
//     resizeCanvas();
//     animate();

//     // Add event listeners
//     canvas.addEventListener('mousemove', handleMouseMove);
//     canvas.addEventListener('mouseleave', handleMouseLeave);

//     // Handle window resize
//     const handleResize = () => {
//       resizeCanvas();
//     };

//     window.addEventListener('resize', handleResize);

//     return () => {
//       cancelAnimationFrame(animationId);
//       canvas.removeEventListener('mousemove', handleMouseMove);
//       canvas.removeEventListener('mouseleave', handleMouseLeave);
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []);

//   // Loading Sequence and Initialization
//   useEffect(() => {
//     const initAnimations = () => {
//       const observerOptions = {
//         threshold: 0.1,
//         rootMargin: '50px 0px -100px 0px'
//       };

//       const observer = new IntersectionObserver((entries) => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             const delay = Array.from(entry.target.parentElement.children).indexOf(entry.target) * 100;

//             setTimeout(() => {
//               entry.target.classList.add('animate-in');
//             }, delay);
//           }
//         });
//       }, observerOptions);

//       // Observe all elements with animations
//       const animatables = document.querySelectorAll(
//         '.hero h1, .hero p, .hero-buttons, ' +
//         '.section-label, .section-title, ' +
//         '.philosophy-card, .capability-item, .process-step, ' +
//         '.positioning-statement, .contact-form-container'
//       );

//       animatables.forEach(el => {
//         observer.observe(el);
//       });

//       // Enhanced Hero animation sequence
//       setTimeout(() => {
//         const heroTitle = document.querySelector('#hero-title');
//         if (heroTitle) heroTitle.classList.add('animate-in');
//         setTimeout(() => {
//           const heroSubtitle = document.querySelector('#hero-subtitle');
//           if (heroSubtitle) heroSubtitle.classList.add('animate-in');
//           setTimeout(() => {
//             const heroButtons = document.querySelector('.hero-buttons');
//             if (heroButtons) heroButtons.classList.add('animate-in');
//           }, 200);
//         }, 300);
//       }, 300);
//     };

//     // Initialize Neural Grid Animation
//     const loadingScreen = loadingScreenRef.current;
//     const navContainer = navContainerRef.current;

//     setTimeout(() => {
//       if (loadingScreen) {
//         loadingScreen.style.opacity = '0';
//         setTimeout(() => {
//           if (loadingScreen) loadingScreen.style.display = 'none';
//           setIsLoading(false);
//           initAnimations();
//         }, 800);
//       }
//     }, 2500);

//     // Navigation always visible
//     if (navContainer) {
//       navContainer.style.opacity = '1';
//       navContainer.style.transform = 'translateY(0)';
//     }

//     // Smooth scroll with offset for fixed nav
//     const handleSmoothScroll = (e) => {
//       const href = e.currentTarget.getAttribute('href');
//       if (href === '#') return;

//       const targetElement = document.querySelector(href);
//       if (targetElement) {
//         const navHeight = document.querySelector('.nav-container')?.offsetHeight || 0;
//         const targetPosition = targetElement.offsetTop - navHeight;

//         window.scrollTo({
//           top: targetPosition,
//           behavior: 'smooth'
//         });

//         // Update active nav link
//         document.querySelectorAll('.nav-link').forEach(link => {
//           link.classList.remove('active');
//         });
//         e.currentTarget.classList.add('active');
        
//         // Close mobile menu if open
//         setIsMobileMenuOpen(false);
//       }
//     };

//     const navLinks = document.querySelectorAll('.nav-link');
//     navLinks.forEach(link => {
//       link.addEventListener('click', handleSmoothScroll);
//     });

//     return () => {
//       navLinks.forEach(link => {
//         link.removeEventListener('click', handleSmoothScroll);
//       });
//     };
//   }, []);

//   // Enhanced Nav scroll effect
//   useEffect(() => {
//     let lastScrollY = window.scrollY;
//     let ticking = false;

//     const handleScroll = () => {
//       const nav = navContainerRef.current;
//       const progress = progressBarRef.current;

//       // Scroll progress
//       const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
//       const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
//       const scrolled = (winScroll / height) * 100;
//       if (progress) progress.style.width = scrolled + "%";

//       // Nav background on scroll with debouncing
//       if (!ticking) {
//         requestAnimationFrame(() => {
//           if (nav) {
//             if (window.scrollY > 50) {
//               nav.classList.add('scrolled');
//             } else {
//               nav.classList.remove('scrolled');
//             }
//           }
//           lastScrollY = window.scrollY;
//           ticking = false;
//         });
//         ticking = true;
//       }

//       // Update active nav link based on scroll position
//       updateActiveNavLink();
//     };

//     // Update active nav link based on scroll
//     const updateActiveNavLink = () => {
//       const sections = document.querySelectorAll('section[id]');
//       const navLinks = document.querySelectorAll('.nav-link');

//       let current = '';
//       sections.forEach(section => {
//         const sectionTop = section.offsetTop;
//         const sectionHeight = section.clientHeight;
//         const navHeight = document.querySelector('.nav-container')?.offsetHeight || 0;

//         if (window.scrollY >= (sectionTop - navHeight - 100)) {
//           current = section.getAttribute('id');
//         }
//       });

//       navLinks.forEach(link => {
//         link.classList.remove('active');
//         if (link.getAttribute('href') === `#${current}`) {
//           link.classList.add('active');
//         }
//       });
//     };

//     window.addEventListener('scroll', handleScroll);

//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);

//   // Mobile Menu Toggle
//   const toggleMobileMenu = () => {
//     setIsMobileMenuOpen(!isMobileMenuOpen);
//   };

//   // Enhanced Contact Form Submission
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const form = e.target;
//     const inputs = form.querySelectorAll('input, textarea');
//     let isValid = true;

//     inputs.forEach(input => {
//       if (!input.value.trim()) {
//         isValid = false;
//         input.style.borderColor = '#ff4757';
//         input.style.boxShadow = '0 0 15px rgba(255, 71, 87, 0.15)';

//         // Shake animation for invalid fields
//         input.style.animation = 'shake 0.5s';
//         setTimeout(() => {
//           input.style.animation = '';
//         }, 500);
//       } else {
//         input.style.borderColor = 'var(--accent-green)';
//         input.style.boxShadow = '0 0 15px var(--glow-green)';
//       }
//     });

//     if (isValid) {
//       // Show loading state
//       const submitBtn = form.querySelector('.submit-button');
//       const originalText = submitBtn.textContent;
//       submitBtn.textContent = 'Sending...';
//       submitBtn.disabled = true;
//       submitBtn.style.opacity = '0.7';

//       // Simulate API call
//       setTimeout(() => {
//         // Hide form, show success message
//         form.style.opacity = '0';
//         form.style.transform = 'translateY(-20px)';

//         setTimeout(() => {
//           form.style.display = 'none';
//           const successMessage = successMessageRef.current;
//           if (successMessage) {
//             successMessage.style.display = 'block';

//             // Animate success message
//             successMessage.style.animation = 'none';
//             setTimeout(() => {
//               successMessage.style.animation = 'messageEntrance 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards';
//             }, 10);
//           }

//           // Reset button
//           submitBtn.textContent = originalText;
//           submitBtn.disabled = false;
//           submitBtn.style.opacity = '1';

//           // Reset form after 6 seconds
//           setTimeout(() => {
//             form.reset();
//             form.style.display = 'block';
//             form.style.opacity = '0';
//             form.style.transform = 'translateY(20px)';

//             setTimeout(() => {
//               form.style.opacity = '1';
//               form.style.transform = 'translateY(0)';
//               if (successMessage) successMessage.style.display = 'none';
//               inputs.forEach(input => {
//                 input.style.borderColor = 'var(--border-grey)';
//                 input.style.boxShadow = 'none';
//               });
//             }, 50);
//           }, 6000);
//         }, 300);
//       }, 1500);
//     }
//   };

//   // Close mobile menu when clicking a link
//   const handleMobileNavClick = (e) => {
//     e.preventDefault();
//     const href = e.currentTarget.getAttribute('href');
    
//     const targetElement = document.querySelector(href);
//     if (targetElement) {
//       const navHeight = document.querySelector('.nav-container')?.offsetHeight || 0;
//       const targetPosition = targetElement.offsetTop - navHeight;

//       window.scrollTo({
//         top: targetPosition,
//         behavior: 'smooth'
//       });

//       // Update active nav link
//       document.querySelectorAll('.nav-link').forEach(link => {
//         link.classList.remove('active');
//       });
//       e.currentTarget.classList.add('active');
      
//       // Close mobile menu
//       setIsMobileMenuOpen(false);
//     }
//   };

//   // Fix mobile menu display
//   useEffect(() => {
//     const mobileMenu = mobileMenuRef.current;
//     if (mobileMenu) {
//       if (isMobileMenuOpen) {
//         // Force display block before adding active class for transition
//         mobileMenu.style.display = 'block';
//         // Small timeout to ensure display is set before adding active class
//         setTimeout(() => {
//           mobileMenu.classList.add('active');
//         }, 10);
//       } else {
//         mobileMenu.classList.remove('active');
//         // Wait for transition to complete before hiding
//         setTimeout(() => {
//           if (!isMobileMenuOpen) {
//             mobileMenu.style.display = 'none';
//           }
//         }, 500); // Match the transition duration
//       }
//     }
//   }, [isMobileMenuOpen]);

//   return (
//     <div className="App">
//       {/* Loading Screen */}
//       <div id="loading-screen" ref={loadingScreenRef} style={{ display: isLoading ? 'flex' : 'none' }}>
//         <div className="logo-load"><span>FIDES.M</span></div>
//       </div>

//       {/* Neural Grid Background */}
//       <canvas className="canvas-bg" id="canvasBg" ref={canvasRef} />

//       {/* Progress Bar */}
//       <div className="progress-bar" ref={progressBarRef} />

//       {/* Navigation */}
//       <nav className="nav-container" ref={navContainerRef}>
//         <a href="#" className="logo">FIDES.M</a>
//         <div className="nav-links">
//           <a href="#philosophy" className="nav-link">Philosophy</a>
//           <a href="#capabilities" className="nav-link">Capabilities</a>
//           <a href="#process" className="nav-link">Process</a>
//           <a href="#positioning" className="nav-link">Approach</a>
//           <a href="#contact" className="nav-link">Contact</a>
//           <a href="#contact" className="cta-button">Start Project</a>
//         </div>
//         <button className="mobile-menu-btn" id="mobileMenuBtn" onClick={toggleMobileMenu}>
//           {isMobileMenuOpen ? '✕' : '☰'}
//         </button>
//       </nav>

//       {/* Mobile Menu */}
//       <div className="mobile-menu" id="mobileMenu" ref={mobileMenuRef}>
//         <div className="mobile-nav-links">
//           <a href="#philosophy" className="nav-link" onClick={handleMobileNavClick}>Philosophy</a>
//           <a href="#capabilities" className="nav-link" onClick={handleMobileNavClick}>Capabilities</a>
//           <a href="#process" className="nav-link" onClick={handleMobileNavClick}>Process</a>
//           <a href="#positioning" className="nav-link" onClick={handleMobileNavClick}>Approach</a>
//           <a href="#contact" className="nav-link" onClick={handleMobileNavClick}>Contact</a>
//           <a href="#contact" className="cta-button" style={{ marginTop: '20px' }} onClick={handleMobileNavClick}>Start Project</a>
//         </div>
//       </div>

//       {/* Hero Section with Clean Floating Container */}
//       <section className="hero">
//         <div className="hero-bg"></div>
//         <div className="hero-container">
//           <div className="hero-content">
//             <h1 id="hero-title">We are Fides.M<br /><span>We build systems and growth engines for businesses that demand control, clarity, and scale.</span></h1>
//             <p id="hero-subtitle">We engineer digital infrastructure for ambitious enterprises. Through precision architecture and strategic automation, we create systems that don't just work they evolve with your vision, driving sustainable growth across global markets.</p>
//             <div className="hero-buttons">
//               <a href="#contact" className="cta-button">Start Your Project</a>
//               <a href="#capabilities" className="cta-button cta-button-secondary">Explore Capabilities</a>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Philosophy Section */}
//       <section className="philosophy" id="philosophy">
//         <div className="container">
//           <div className="section-header">
//             <div className="section-label" id="philosophy-label">Strategic Philosophy</div>
//             <h2 className="section-title" id="philosophy-title">Most businesses don't need more tools.<br />They need <strong>structure</strong>.</h2>
//           </div>
//           <div className="philosophy-grid">
//             <div className="philosophy-card" id="internal-growth">
//               <h3>Internal Growth Systems</h3>
//               <p>We architect comprehensive operational frameworks that eliminate friction. From automated workflow systems to real-time performance dashboards, we build the internal machinery that allows your business to scale seamlessly while maintaining complete control.</p>
//             </div>
//             <div className="philosophy-card" id="external-growth">
//               <h3>External Market Dominance</h3>
//               <p>Beyond brand identity, we engineer market positioning systems that command authority. Our strategic approach combines data-driven insights with premium design to create digital experiences that convert visitors into advocates and competitors into followers.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Capabilities Section */}
//       <section className="capabilities" id="capabilities">
//         <div className="container">
//           <div className="section-header">
//             <div className="section-label" id="capabilities-label">Core Capabilities</div>
//             <h2 className="section-title" id="capabilities-title">Business Infrastructure Engineering</h2>
//           </div>
//           <div className="capabilities-grid">
//             <div className="capability-item" id="software-systems">
//               <div className="capability-icon">⚙</div>
//               <h3>Enterprise Software Systems</h3>
//               <p>Custom business intelligence platforms, secure management systems, and scalable enterprise solutions built on robust architecture.</p>
//             </div>
//             <div className="capability-item" id="digital-systems">
//               <div className="capability-icon">▣</div>
//               <h3>Digital Infrastructure</h3>
//               <p>Cloud-native architectures, microservices ecosystems, and future-proof digital foundations engineered for global scale.</p>
//             </div>
//             <div className="capability-item" id="uiux-design">
//               <div className="capability-icon">✎</div>
//               <h3>Strategic UI/UX Design</h3>
//               <p>Interface systems that balance aesthetic precision with functional depth, engineered for optimal user cognition and conversion.</p>
//             </div>
//             <div className="capability-item" id="website-creation">
//               <div className="capability-icon">◉</div>
//               <h3>Premium Web Platforms</h3>
//               <p>Performance-optimized web architectures that serve as your digital headquarters, combining technical excellence with brand authority.</p>
//             </div>
//             <div className="capability-item" id="digital-marketing">
//               <div className="capability-icon">▲</div>
//               <h3>Growth Marketing Systems</h3>
//               <p>Data-driven marketing infrastructure that builds trust, accelerates acquisition, and optimizes customer lifetime value.</p>
//             </div>
//             <div className="capability-item" id="automation">
//               <div className="capability-icon">⌀</div>
//               <h3>Intelligent Automation</h3>
//               <p>Workflow automation systems that eliminate complexity, reduce operational overhead, and enhance decision-making velocity.</p>
//             </div>
//           </div>
//           <div style={{ textAlign: 'center' }}>
//             <a href="#contact" className="cta-button">Discuss Your Infrastructure Needs</a>
//           </div>
//         </div>
//       </section>

//       {/* Process Section */}
//       <section className="process" id="process">
//         <div className="container">
//           <div className="section-header">
//             <div className="section-label" id="process-label">Our Methodology</div>
//             <h2 className="section-title" id="process-title">Architecture Through Precision</h2>
//           </div>
//           <div className="process-steps">
//             <div className="process-step" id="step1">
//               <div className="step-indicator">01</div>
//               <h3 className="step-title">Strategic Understanding</h3>
//               <p className="step-description">Deep-dive analysis of business objectives, market positioning, and technical requirements to establish architectural foundations.</p>
//             </div>
//             <div className="process-step" id="step2">
//               <div className="step-indicator">02</div>
//               <h3 className="step-title">System Architecture</h3>
//               <p className="step-description">Designing scalable system blueprints, interface hierarchies, and technological frameworks for optimal performance flow.</p>
//             </div>
//             <div className="process-step" id="step3">
//               <div className="step-indicator">03</div>
//               <h3 className="step-title">Precision Engineering</h3>
//               <p className="step-description">Implementation with clean, maintainable code following enterprise-grade development standards and security protocols.</p>
//             </div>
//             <div className="process-step" id="step4">
//               <div className="step-indicator">04</div>
//               <h3 className="step-title">Growth Optimization</h3>
//               <p className="step-description">Continuous performance monitoring, strategic scaling, and infrastructure evolution to support sustainable expansion.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Positioning Section */}
//       <section className="positioning" id="positioning">
//         <div className="container">
//           <p className="positioning-statement" id="positioning-text">
//             We don't sell deliverables.<br />
//             We build <strong>infrastructure for real businesses</strong>.
//           </p>
//         </div>
//       </section>

import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import ContactForm from "./ContactForm";

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const canvasRef = useRef(null);
  const loadingScreenRef = useRef(null);
  const navContainerRef = useRef(null);
  const progressBarRef = useRef(null);
  const contactFormRef = useRef(null);
  const successMessageRef = useRef(null);
  const mobileMenuRef = useRef(null);

  // Neural Grid Animation
  useEffect(() => {
    if (!canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationId;

    // Grid configuration
    const grid = {
      nodes: [],
      connections: [],
      mouseInfluenceRadius: 200,
      originalPositions: new Map(),
      isMouseOver: false,
      mouseX: 0,
      mouseY: 0
    };

    // Resize canvas
    function resizeCanvas() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      initGrid();
    }

    // Initialize grid nodes
    function initGrid() {
      grid.nodes = [];
      grid.connections = [];
      grid.originalPositions.clear();

      // Create high-density grid
      const spacing = 40;
      const cols = Math.ceil(canvas.width / spacing) + 1;
      const rows = Math.ceil(canvas.height / spacing) + 1;

      // Create nodes
      for (let y = 0; y < rows; y++) {
        for (let x = 0; x < cols; x++) {
          const node = {
            x: x * spacing,
            y: y * spacing,
            originalX: x * spacing,
            originalY: y * spacing,
            velocityX: 0,
            velocityY: 0,
            size: Math.random() * 1.2 + 0.3
          };
          grid.nodes.push(node);
          grid.originalPositions.set(node, { x: node.x, y: node.y });
        }
      }

      // Create connections
      for (let i = 0; i < grid.nodes.length; i++) {
        for (let j = i + 1; j < grid.nodes.length; j++) {
          const nodeA = grid.nodes[i];
          const nodeB = grid.nodes[j];
          const distance = Math.sqrt(
            Math.pow(nodeA.x - nodeB.x, 2) +
            Math.pow(nodeA.y - nodeB.y, 2)
          );

          if (distance < spacing * 1.8) {
            grid.connections.push({
              nodeA: nodeA,
              nodeB: nodeB,
              distance: distance
            });
          }
        }
      }
    }

    // Physics update
    function updatePhysics() {
      const damping = 0.9;
      const springStrength = 0.08;
      const mouseStrength = 0.3;

      grid.nodes.forEach(node => {
        // Return to original position force
        const dx = node.originalX - node.x;
        const dy = node.originalY - node.y;

        // Spring force
        node.velocityX += dx * springStrength;
        node.velocityY += dy * springStrength;

        // Mouse attraction
        if (grid.isMouseOver) {
          const mouseDx = grid.mouseX - node.x;
          const mouseDy = grid.mouseY - node.y;
          const mouseDistance = Math.sqrt(mouseDx * mouseDx + mouseDy * mouseDy);

          if (mouseDistance < grid.mouseInfluenceRadius) {
            const influence = 1 - (mouseDistance / grid.mouseInfluenceRadius);
            node.velocityX += mouseDx * influence * mouseStrength;
            node.velocityY += mouseDy * influence * mouseStrength;
          }
        }

        // Apply velocity with damping
        node.x += node.velocityX;
        node.y += node.velocityY;
        node.velocityX *= damping;
        node.velocityY *= damping;

        // Prevent excessive drifting
        const maxDrift = 30;
        const currentDx = node.x - node.originalX;
        const currentDy = node.y - node.originalY;
        const currentDistance = Math.sqrt(currentDx * currentDx + currentDy * currentDy);

        if (currentDistance > maxDrift) {
          const angle = Math.atan2(currentDy, currentDx);
          node.x = node.originalX + Math.cos(angle) * maxDrift;
          node.y = node.originalY + Math.sin(angle) * maxDrift;
        }
      });
    }

    // Render grid
    function renderGrid() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Draw connections
      ctx.strokeStyle = 'rgba(42, 140, 110, 0.1)';
      ctx.lineWidth = 0.5;

      grid.connections.forEach(conn => {
        const currentDistance = Math.sqrt(
          Math.pow(conn.nodeA.x - conn.nodeB.x, 2) +
          Math.pow(conn.nodeA.y - conn.nodeB.y, 2)
        );

        if (currentDistance < 80) {
          const opacity = Math.max(0.02, 0.15 * (1 - currentDistance / 80));
          ctx.strokeStyle = `rgba(42, 140, 110, ${opacity})`;

          ctx.beginPath();
          ctx.moveTo(conn.nodeA.x, conn.nodeA.y);
          ctx.lineTo(conn.nodeB.x, conn.nodeB.y);
          ctx.stroke();
        }
      });

      // Draw nodes
      grid.nodes.forEach(node => {
        // Calculate brightness based on mouse proximity
        let brightness = 1;
        if (grid.isMouseOver) {
          const dx = grid.mouseX - node.x;
          const dy = grid.mouseY - node.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          if (distance < grid.mouseInfluenceRadius) {
            brightness = 0.6 + 0.4 * (1 - distance / grid.mouseInfluenceRadius);
          }
        }

        // Brand color #2a8c6e
        const r = Math.floor(42 * brightness);
        const g = Math.floor(140 * brightness);
        const b = Math.floor(110 * brightness);

        // Draw node
        ctx.fillStyle = `rgb(${r}, ${g}, ${b})`;
        ctx.beginPath();
        ctx.arc(node.x, node.y, node.size, 0, Math.PI * 2);
        ctx.fill();

        // Draw subtle glow
        const gradient = ctx.createRadialGradient(
          node.x, node.y, node.size,
          node.x, node.y, node.size * 2.5
        );
        gradient.addColorStop(0, `rgba(42, 140, 110, 0.4)`);
        gradient.addColorStop(1, 'transparent');

        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.arc(node.x, node.y, node.size * 2.5, 0, Math.PI * 2);
        ctx.fill();
      });
    }

    // Animation loop
    function animate() {
      updatePhysics();
      renderGrid();
      animationId = requestAnimationFrame(animate);
    }

    // Mouse event handlers
    const handleMouseMove = (e) => {
      grid.mouseX = e.clientX;
      grid.mouseY = e.clientY;
      grid.isMouseOver = true;
    };

    const handleMouseLeave = () => {
      grid.isMouseOver = false;
    };

    // Initialize and start
    resizeCanvas();
    animate();

    // Add event listeners
    canvas.addEventListener('mousemove', handleMouseMove);
    canvas.addEventListener('mouseleave', handleMouseLeave);

    // Handle window resize
    const handleResize = () => {
      resizeCanvas();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      cancelAnimationFrame(animationId);
      canvas.removeEventListener('mousemove', handleMouseMove);
      canvas.removeEventListener('mouseleave', handleMouseLeave);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Loading Sequence and Initialization
  useEffect(() => {
    const initAnimations = () => {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '50px 0px -100px 0px'
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = Array.from(entry.target.parentElement.children).indexOf(entry.target) * 100;

            setTimeout(() => {
              entry.target.classList.add('animate-in');
            }, delay);
          }
        });
      }, observerOptions);

      // Observe all elements with animations
      const animatables = document.querySelectorAll(
        '.hero h1, .hero p, .hero-buttons, ' +
        '.section-label, .section-title, ' +
        '.philosophy-card, .capability-item, .process-step, ' +
        '.positioning-statement, .contact-form-container'
      );

      animatables.forEach(el => {
        observer.observe(el);
      });

      // Enhanced Hero animation sequence
      setTimeout(() => {
        const heroTitle = document.querySelector('#hero-title');
        if (heroTitle) heroTitle.classList.add('animate-in');
        setTimeout(() => {
          const heroSubtitle = document.querySelector('#hero-subtitle');
          if (heroSubtitle) heroSubtitle.classList.add('animate-in');
          setTimeout(() => {
            const heroButtons = document.querySelector('.hero-buttons');
            if (heroButtons) heroButtons.classList.add('animate-in');
          }, 200);
        }, 300);
      }, 300);
    };

    // Initialize Neural Grid Animation
    const loadingScreen = loadingScreenRef.current;
    const navContainer = navContainerRef.current;

    setTimeout(() => {
      if (loadingScreen) {
        loadingScreen.style.opacity = '0';
        setTimeout(() => {
          if (loadingScreen) loadingScreen.style.display = 'none';
          setIsLoading(false);
          initAnimations();
        }, 800);
      }
    }, 2500);

    // Navigation always visible
    if (navContainer) {
      navContainer.style.opacity = '1';
      navContainer.style.transform = 'translateY(0)';
    }

    // Smooth scroll with offset for fixed nav
    const handleSmoothScroll = (e) => {
      const href = e.currentTarget.getAttribute('href');
      if (href === '#') return;

      const targetElement = document.querySelector(href);
      if (targetElement) {
        const navHeight = document.querySelector('.nav-container')?.offsetHeight || 0;
        const targetPosition = targetElement.offsetTop - navHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });

        // Update active nav link
        document.querySelectorAll('.nav-link').forEach(link => {
          link.classList.remove('active');
        });
        e.currentTarget.classList.add('active');
        
        // Close mobile menu if open
        setIsMobileMenuOpen(false);
      }
    };

    const navLinks = document.querySelectorAll('.nav-link');
    navLinks.forEach(link => {
      link.addEventListener('click', handleSmoothScroll);
    });

    return () => {
      navLinks.forEach(link => {
        link.removeEventListener('click', handleSmoothScroll);
      });
    };
  }, []);

  // Enhanced Nav scroll effect
  useEffect(() => {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const handleScroll = () => {
      const nav = navContainerRef.current;
      const progress = progressBarRef.current;

      // Scroll progress
      const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = (winScroll / height) * 100;
      if (progress) progress.style.width = scrolled + "%";

      // Nav background on scroll with debouncing
      if (!ticking) {
        requestAnimationFrame(() => {
          if (nav) {
            if (window.scrollY > 50) {
              nav.classList.add('scrolled');
            } else {
              nav.classList.remove('scrolled');
            }
          }
          lastScrollY = window.scrollY;
          ticking = false;
        });
        ticking = true;
      }

      // Update active nav link based on scroll position
      updateActiveNavLink();
    };

    // Update active nav link based on scroll
    const updateActiveNavLink = () => {
      const sections = document.querySelectorAll('section[id]');
      const navLinks = document.querySelectorAll('.nav-link');

      let current = '';
      sections.forEach(section => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.clientHeight;
        const navHeight = document.querySelector('.nav-container')?.offsetHeight || 0;

        if (window.scrollY >= (sectionTop - navHeight - 100)) {
          current = section.getAttribute('id');
        }
      });

      navLinks.forEach(link => {
        link.classList.remove('active');
        if (link.getAttribute('href') === `#${current}`) {
          link.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Mobile Menu Toggle
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Enhanced Contact Form Submission
  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.target;
    const inputs = form.querySelectorAll('input, textarea');
    let isValid = true;

    inputs.forEach(input => {
      if (!input.value.trim()) {
        isValid = false;
        input.style.borderColor = '#ff4757';
        input.style.boxShadow = '0 0 15px rgba(255, 71, 87, 0.15)';

        // Shake animation for invalid fields
        input.style.animation = 'shake 0.5s';
        setTimeout(() => {
          input.style.animation = '';
        }, 500);
      } else {
        input.style.borderColor = 'var(--accent-green)';
        input.style.boxShadow = '0 0 15px var(--glow-green)';
      }
    });

    if (isValid) {
      // Show loading state
      const submitBtn = form.querySelector('.submit-button');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Sending...';
      submitBtn.disabled = true;
      submitBtn.style.opacity = '0.7';

      // Simulate API call
      setTimeout(() => {
        // Hide form, show success message
        form.style.opacity = '0';
        form.style.transform = 'translateY(-20px)';

        setTimeout(() => {
          form.style.display = 'none';
          const successMessage = successMessageRef.current;
          if (successMessage) {
            successMessage.style.display = 'block';

            // Animate success message
            successMessage.style.animation = 'none';
            setTimeout(() => {
              successMessage.style.animation = 'messageEntrance 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards';
            }, 10);
          }

          // Reset button
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
          submitBtn.style.opacity = '1';

          // Reset form after 6 seconds
          setTimeout(() => {
            form.reset();
            form.style.display = 'block';
            form.style.opacity = '0';
            form.style.transform = 'translateY(20px)';

            setTimeout(() => {
              form.style.opacity = '1';
              form.style.transform = 'translateY(0)';
              if (successMessage) successMessage.style.display = 'none';
              inputs.forEach(input => {
                input.style.borderColor = 'var(--border-grey)';
                input.style.boxShadow = 'none';
              });
            }, 50);
          }, 6000);
        }, 300);
      }, 1500);
    }
  };

  // Close mobile menu when clicking a link
  const handleMobileNavClick = (e) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute('href');
    
    const targetElement = document.querySelector(href);
    if (targetElement) {
      const navHeight = document.querySelector('.nav-container')?.offsetHeight || 0;
      const targetPosition = targetElement.offsetTop - navHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      // Update active nav link
      document.querySelectorAll('.nav-link').forEach(link => {
        link.classList.remove('active');
      });
      e.currentTarget.classList.add('active');
      
      // Close mobile menu
      setIsMobileMenuOpen(false);
    }
  };

  // Fix mobile menu display
  useEffect(() => {
    const mobileMenu = mobileMenuRef.current;
    if (mobileMenu) {
      if (isMobileMenuOpen) {
        // Force display block before adding active class for transition
        mobileMenu.style.display = 'block';
        // Small timeout to ensure display is set before adding active class
        setTimeout(() => {
          mobileMenu.classList.add('active');
        }, 10);
      } else {
        mobileMenu.classList.remove('active');
        // Wait for transition to complete before hiding
        setTimeout(() => {
          if (!isMobileMenuOpen) {
            mobileMenu.style.display = 'none';
          }
        }, 500); // Match the transition duration
      }
    }
  }, [isMobileMenuOpen]);

  return (
    <div className="App">
      {/* Loading Screen */}
      <div id="loading-screen" ref={loadingScreenRef} style={{ display: isLoading ? 'flex' : 'none' }}>
        <div className="logo-load"><span>FIDES.M</span></div>
      </div>

      {/* Neural Grid Background */}
      <canvas className="canvas-bg" id="canvasBg" ref={canvasRef} />

      {/* Progress Bar */}
      <div className="progress-bar" ref={progressBarRef} />

      {/* Navigation */}
      <nav className="nav-container" ref={navContainerRef}>
        <a href="#" className="logo">FIDES.M</a>
        <div className="nav-links">
          <a href="#philosophy" className="nav-link">Philosophy</a>
          <a href="#capabilities" className="nav-link">Capabilities</a>
          <a href="#process" className="nav-link">Process</a>
          <a href="#positioning" className="nav-link">Approach</a>
          <a href="#contact" className="nav-link">Contact</a>
          <a href="#contact" className="cta-button">Start Project</a>
        </div>
        <button className="mobile-menu-btn" id="mobileMenuBtn" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? '✕' : '☰'}
        </button>
      </nav>

      {/* Mobile Menu */}
      <div className="mobile-menu" id="mobileMenu" ref={mobileMenuRef}>
        <div className="mobile-nav-links">
          <a href="#philosophy" className="nav-link" onClick={handleMobileNavClick}>Philosophy</a>
          <a href="#capabilities" className="nav-link" onClick={handleMobileNavClick}>Capabilities</a>
          <a href="#process" className="nav-link" onClick={handleMobileNavClick}>Process</a>
          <a href="#positioning" className="nav-link" onClick={handleMobileNavClick}>Approach</a>
          <a href="#contact" className="nav-link" onClick={handleMobileNavClick}>Contact</a>
          <a href="#contact" className="cta-button" style={{ marginTop: '20px' }} onClick={handleMobileNavClick}>Start Project</a>
        </div>
      </div>

      {/* Hero Section with Clean Floating Container */}
      <section className="hero">
        <div className="hero-bg"></div>
        <div className="hero-container">
          <div className="hero-content">
            <h1 id="hero-title">We are Fides.M<br /><span>We build software that helps businesses run Faster, Easier and Smarter.</span></h1>
            <p id="hero-subtitle">We build practical systems that help companies manage operations, track performance, and make smarter decisions.<br/>  All from one place.</p>
            <div className="hero-buttons">
              <a href="#contact" className="cta-button">Start Your Project</a>
              <a href="#capabilities" className="cta-button cta-button-secondary">Explore Capabilities</a>
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="philosophy" id="philosophy">
        <div className="container">
          <div className="section-header">
            <div className="section-label" id="philosophy-label">Strategic Philosophy</div>
            <h2 className="section-title" id="philosophy-title">Businesses don’t need more tools<br />They need <strong>clarity</strong>.</h2>
          </div>
          <div className="philosophy-grid">
            <div className="philosophy-card" id="internal-growth">
              <h3 >Real Visibility</h3>
              <p>When you can see what’s happening inside your business, you make better decisions. Our systems give you clear data, simple dashboards, and real control.</p>
            </div>
            <div className="philosophy-card" id="external-growth">
              <h3>Built to Scale</h3>
              <p>We create software designed to grow with your business. No complexity. No chaos. Just systems that keep working as you expand.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Capabilities Section */}
      <section className="capabilities" id="capabilities">
        <div className="container">
          <div className="section-header">
            <div className="section-label" id="capabilities-label">Core Capabilities</div>
            <h2 className="section-title" id="capabilities-title">What Our Systems Help <br/>You Do.</h2>
          </div>
          <div className="capabilities-grid">
            <div className="capability-item" id="software-systems">
              <div className="capability-icon">⚙</div>
              <h3>Software Systems</h3>                       
              <p>Manage your business operations, cash flow, customers or clients, your team, and your stocks all in one place.</p>
            </div>
            <div className="capability-item" id="digital-systems">
              <div className="capability-icon">▣</div>
              <h3>Infrastructure</h3>
              <p>Reliable cloud systems that keep your business operations running smoothly 24/7.</p>
            </div>
            <div className="capability-item" id="uiux-design">
              <div className="capability-icon">✎</div>
              <h3>Interface Design</h3>
              <p>Clean, simple dashboards that are easy for You, Your team, and your Clients to use and understand.</p>
            </div>
            <div className="capability-item" id="website-creation">
              <div className="capability-icon">◉</div>
              <h3>Web Platforms</h3>
              <p>Fast and secure platforms that act as the digital control center for your entire business.</p>
            </div>
            <div className="capability-item" id="digital-marketing">
              <div className="capability-icon">▲</div>
              <h3>Analytics</h3>
              <p>Get clear numbers on your business so you can see exactly what’s working and what to improve.</p>
            </div>
            <div className="capability-item" id="automation">
              <div className="capability-icon">⌀</div>
              <h3>Automation</h3>
              <p>Stop wasting time on manual tasks with smart workflows that do the work for you</p>
            </div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <a href="#contact" className="cta-button">Discuss Your Infrastructure Needs</a>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process" id="process">
        <div className="container">
          <div className="section-header">
            <div className="section-label" id="process-label">Our Methodology</div>
            <h2 className="section-title" id="process-title">Architecture Through Precision</h2>
          </div>
          <div className="process-steps">
            <div className="process-step" id="step1">
              <div className="step-indicator">01</div>
              <h3 className="step-title">Understand</h3>
              <p className="step-description">We deep-dive into your business operations to analyze exactly what’s missing and what you need to scale.</p>
            </div>
            <div className="process-step" id="step2">
              <div className="step-indicator">02</div>
              <h3 className="step-title">Setup</h3>
              <p className="step-description">We configure and customize our core systems to align perfectly with your specific business operations.</p>
            </div>
            <div className="process-step" id="step3">
              <div className="step-indicator">03</div>
              <h3 className="step-title">Launch</h3>
              <p className="step-description">You and your team start using the system immediately with full support to ensure a seamless transition.</p>
            </div>
            <div className="process-step" id="step4">
              <div className="step-indicator">04</div>
              <h3 className="step-title">Improve</h3>
              <p className="step-description">We continuously monitor performance and evolve your system with new features as your business scales.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Positioning Section */}
      <section className="positioning" id="positioning">
        <div className="container">
          <p className="positioning-statement" id="positioning-text">
            We don't sell deliverables.<br />
            We build <strong>infrastructure for real businesses</strong>.
          </p>
        </div>
      </section>

    <ContactForm />
      {/* Contact Section */}
      {/*<section className="contact" id="contact">*/}
      {/*  <div className="container">*/}
      {/*    <div className="contact-header">*/}
      {/*      <div className="section-label" id="contact-label">Begin the Conversation</div>*/}
      {/*      <h2 className="section-title" id="contact-title">Let's build something serious.</h2>*/}
      {/*    </div>*/}
      {/*    <div className="contact-form-container">*/}
      {/*      <form id="contact-form" onSubmit={handleSubmit} ref={contactFormRef}>*/}
      {/*        <div className="form-group">*/}
      {/*          <label htmlFor="name">Full Name</label>*/}
      {/*          <input type="text" id="name" name="name" placeholder="Your Name" required />*/}
      {/*        </div>*/}
      {/*        <div className="form-group">*/}
      {/*          <label htmlFor="email">Business Email</label>*/}
      {/*          <input type="email" id="email" name="email" placeholder="Your@company.com" required />*/}
      {/*        </div>*/}
      {/*        <div className="form-group">*/}
      {/*          <label htmlFor="business">Company Name</label>*/}
      {/*          <input type="text" id="business" name="business" placeholder="Your Company Name." required />*/}
      {/*        </div>*/}
      {/*        <div className="form-group">*/}
      {/*          <label htmlFor="project">Project Overview</label>*/}
      {/*          <textarea id="project" name="project" placeholder="Describe your infrastructure needs, challenges, and vision for growth..." required></textarea>*/}
      {/*        </div>*/}
      {/*        <button type="submit" className="submit-button">Submit Project Inquiry</button>*/}
      {/*      </form>*/}
      {/*      <div id="success-message" className="success-message" ref={successMessageRef}>*/}
      {/*        Thank you. We'll review your inquiry and contact you within 24 hours.*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</section>*/}

      {/* Footer */}
      <footer className="footer">
  <div className="footer-container">
    <div className="footer-brand">
      <a href="#" className="footer-logo">FIDES.M</a>
      <p>Engineering high-performance digital infrastructure for modern enterprises.</p>
    </div>

    <div className="footer-section">
      <h4 className="footer-heading">Navigation</h4>
      <ul className="footer-links">
        <li><a href="#philosophy">Philosophy</a></li>
        <li><a href="#capabilities">Capabilities</a></li>
        <li><a href="#process">Process</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>
    </div>

    <div className="footer-section">
      <h4 className="footer-heading">Connect</h4>
      <ul className="footer-links">
        
        <li><a href="https://www.instagram.com/fides.management?igsh=Zjh1ZjBsZnZydGE2" target="_blank" rel="noreferrer">Instagram</a></li>
        <li><a href="https://www.tiktok.com/@fides.m?_t=ZS-90it6Gnv1aG&_r=1" target="_blank" rel="noreferrer">Tiktok</a></li>
        <li><a href="https://www.facebook.com/fides.management" target="_blank" rel="noreferrer">Facebook</a></li>
      </ul>
    </div>

    <div className="footer-section">
      <h4 className="footer-heading">Inquiries</h4>
      <ul className="footer-links">
        <li><a href="tel:+94757180225">+94 75 718 0225</a></li>
        <li><a href="info@fidesm.dev">info@fidesm.dev</a></li>
        <li><a href="#contact">Start a Project</a></li>
        <li><a href="#contact">Consultation</a></li>
      </ul>
    </div>
  </div>

  <div className="footer-bottom">
    <div className="copyright">
      © 2026 FIDES.M — All rights reserved.
    </div>
    <div className="footer-legal">
      
    </div>
  </div>
</footer>
    </div>
  );
}

export default App;
